import {Injectable} from '@angular/core';
import {UserInteractor} from '../../interactors/user.interactor';
import {PostLoginLoanApplicationFlowStep} from './post-login-loan-application-flow.step';
import {LoanApplicationInteractor} from '../../interactors/loan-application.interactor';
import {isEmpty} from 'lodash';

@Injectable()
export class PersonalInformationStep extends PostLoginLoanApplicationFlowStep {
    constructor(userInteractor: UserInteractor, private loanApplicationInteractor: LoanApplicationInteractor) {
        super(userInteractor);
    }

    description(): string {
        return 'It’s important for us to know you';
    }

    displayName(): string {
        return 'Personal Information';
    }

    url(): string {
        return this.createBorrowerFlowUrl('personal-info');
    }

    async isStepComplete(): Promise<boolean> {
        const user = await this.userInteractor.get();
        const loanApplication = await this.loanApplicationInteractor.get();
        return !(isEmpty(user) || isEmpty(user.gender) || isEmpty(user.marital_status)
            || isEmpty(user.educational_qualification) || isEmpty(user.dob) || isEmpty(loanApplication
                && loanApplication.addressId));
    }
}
